<template>
    <div class="comments_list_card input " id="comments_input_wrapper" v-if="isLogin">
        <div class="card_avatar">
            <img :src="avatar" alt="" class="card_avatar_img" id="input_avatar">
        </div>
        <div class="card_content form-group input_wrapper textarea" id="comments_input">
            <div class="form-control">
                <textarea ref="comment_area" name="" id="comments_input" rows="1" :placeholder="inputPlaceholder" maxlength="500" @click="checkPermission" @focus="inputFocusFunc" @blur="inputBlurFunc" v-model="commentText"></textarea>
                <a href="javascript:void(0);" class="comments_submit_btn" v-show="showBtns || commentText.length!==0" @click="preSubmitComment">發佈</a>
            </div>
            <p class="textarea_desc">上限500字</p>
        </div>
    </div>
    <div class="comments_list_card input " id="comments_input_wrapper" v-else>
        <div class="card_content form-group input_wrapper textarea" id="comments_input">
            <div class="form-control">
                <textarea name="" id="comments_input" placeholder="登入世界走走會員發表評論" rows="1" @click="$emit('show-login')" @focus="inputFocusFunc" @blur="inputBlurFunc"></textarea>
                <a href="javascript:void(0);" class="comments_submit_btn" @click="$emit('show-login')">登入</a>
            </div>
        </div>
    </div>
    <img src="/images/ajax-loader.gif" class="loading_indicator" v-show="sending">
    <comment-error-dialog @panel-modal="panelModal" :error-message="errorMessage" :button-text="buttonText"></comment-error-dialog>
</template>

<script>
    import CommentErrorDialog from './CommentErrorDialog';
    import { commentPost } from '@vuePath/api/article';
    import {inputFocus, inputBlur} from "@vuePath/tools/tool";
    import autosize from 'autosize';
    export default {
        emits: ['reload-comment', 'show-login'],
        props: {
            nid: {
                type: String,
                required: true
            },
            isLogin: {
                type: Boolean,
                required: true
            },
            isPremium: {
                type: Boolean,
                default: false
            },
            avatar: {
                type: String
            }
        },
        components: {
            CommentErrorDialog,
        },
        data () {
            return {
                showBtns: false,
                commentText: '',
                errorMessage: '',
                buttonText: '',
                sending: false
            }
        },
        methods: {
            panelModal(is_open) {
                if (is_open) {
                    window.$('#modal_default_sm').modal('show');
                } else {
                    window.$('#modal_default_sm').modal('hide');
                }
            },
            checkPermission() {
                if (this.isPremium) {
                    this.showBtns = true;
                } else {
                    this.fail('請先訂閱世界走走付費會員才能發表留言！', '回到文章');
                }
            },
            preSubmitComment(event) {

                event.preventDefault();
                if (this.sending) {
                    return;
                }
                this.sending = true;
                this.submitComment()
                    .then(response => {
                        this.showBtns = false;
                        this.commentText = '';
                        this.sending = false;
                    })
                    .catch((err) => {
                        this.sending = false;
                        this.fail();
                    });
            },
            submitComment() {
                return new Promise((resolve, reject) => {
                    commentPost(this.nid, this.commentText)
                        .then(response => {
                            if (response.data.code === '000') {
                                this.$emit('reload-comment');
                            } else if (response.data.code === '401') {
                                this.fail('請先訂閱世界走走會員才能發表留言！', '回到文章');
                            } else {
                                this.fail('留言失敗');
                            }
                            resolve(response);
                        })
                        .catch(function (err) {
                            reject(err);
                        });
                });
            },
            fail(message='系統錯誤', text='返回') {
                this.errorMessage = message;
                this.buttonText = text;
                this.panelModal(true);
            },
            inputFocusFunc(e) {
                inputFocus(e);
            },
            inputBlurFunc(e) {
                inputBlur(e);
                this.showBtns=false;
            }
        },
        mounted() {
            autosize(this.$refs.comment_area);
        },
        computed: {
            inputPlaceholder() {
                return (this.isPremium) ? '新增留言.....' : '訂閱成為世界走走付費會員即可發表評論';
            }
        }
    };
</script>